import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import "./add-content.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { clearErrors } from "../../../../ActionCreators/errorAction";
import { getQuizzes, getSkills } from '../../../../ActionCreators/AdminAction/adminTestAction';
import Snackbar from '@mui/material/Snackbar';
import Select, { components } from 'react-select';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};


function QuizList(props) {
    const [skill, setSkill] = useState(null);
    const [quizId, setQuizId] = useState('');
    // const navigate = useNavigate();
    const history = useHistory();

    useEffect(() => {
        console.log(props)
        props.getSkills();
        setSkill({ label: props.skill, value: props.skillId });
        props.getQuizzes(props.skillId);
    }, []);





    const backToMain = () => {
        props.backToMain();
    };

    const getSkill = (e) => {
        setSkill(e)
        props.getQuizzes(e?.value);
    }


    const snackClosed = () => {
        props.clearErrors();
    }

    const selectQuiz = (detail) => {
        setQuizId(detail?._id);
    }

    const addQuiz = async () => {
        await props.quizData(quizId);
    }

    const goToAddQuiz = (edit, type) => {
        history.push({ pathname: '/manage-tests/add', state: { edit, type } });
    }



    const { quizzes } = props;
    return (
        <Fragment>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={props.successMessage}
                onClose={() => snackClosed()}
                message={props.successMessageText}
                autoHideDuration={4000}
            />
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={props.successEnable}
                onClose={() => snackClosed()}
                message={props.successMessageText}
                autoHideDuration={4000}
            />

            <div className="manage-content-holder managequiz">
                <Fragment>
                    <div style={{ fontSize: 20, cursor: "pointer" }}>
                        <div className="d-flex align-items-center">
                            <p
                                style={{ marginTop: 5 }}
                                onClick={() => history.goBack()}
                            >
                                <img src="/images/back.svg" alt="" width="20px" />
                            </p>
                            <div className="ml-2">
                                <h1>Add Quiz</h1>

                            </div>

                            <button
                                className="ml-auto quizButton"
                                onClick={() => addQuiz()}
                            >
                                Done <span className="arrow-right"></span>
                            </button>
                        </div>
                    </div>
                    <div className="content-heading">
                        <div className="content-header">
                            <div className='d-flex justify-content-between align-items-center'>
                                <p className='pl-0'>
                                    Select quiz from the list below or{" "}
                                    <b className='cursor-pointer'
                                        onClick={() => {
                                            goToAddQuiz(false, 'quiz')
                                        }}
                                    >
                                        Add New Quiz
                                    </b>
                                </p>
                                <div style={{ width: '30%', marginTop: -20 }}>
                                    <Select
                                        components={{ DropdownIndicator }}
                                        options={props.skillList?.map(el => [{ label: el.title, value: el._id }][0])}
                                        onChange={getSkill}
                                        placeholder='Select Skill'
                                        value={skill}
                                    />
                                </div>
                            </div>
                            <ul>
                                <li>
                                    <div className="first-row">Select</div>
                                    <div>Title</div>
                                    <div>Subject</div>
                                    <div>Questions</div>
                                    <div></div>
                                </li>
                            </ul>
                        </div>
                        <ul className="program-list">
                            {quizzes !== undefined && quizzes?.length ?
                                quizzes.map((el, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="program-name first-row">
                                                <td>
                                                    <input
                                                        type="radio"
                                                        className="mr-3"
                                                        name="radio1"
                                                        style={{ width: 18, height: 18 }}
                                                        onClick={(e) => {
                                                            selectQuiz(el);
                                                        }}
                                                    />
                                                </td>
                                            </div>
                                            <div className="program-name text-center">
                                                <p>{el.title}</p>
                                            </div>
                                            <div className="text-center">
                                                <p>{el.skill?.title}</p>
                                            </div>
                                            <div className="text-center">
                                                <h3>{el.questions?.length}</h3>
                                            </div>
                                            <div className="text-center">
                                                {/* View questions &nbsp;&nbsp; */}
                                            </div>
                                        </li>
                                    )
                                })
                                :
                                <div className="empty-list">
                                    <img src="/images/empty.png" alt="" />
                                    <p>You have not added any Quiz yet.</p>
                                </div>
                            }
                        </ul>
                    </div>
                    {/* ) : (
            <div className="empty-list">
              <img src="/images/empty.png" alt="" />
              <p>You have not added any Questions yet.</p>
            </div>
            )} */}
                </Fragment>
            </div>
        </Fragment>
    );
}



const mapStateToProps = (state) => {
    const { quizzes, skillList } = state.adminTest;
    const { successMessageText, successMessage, successEnable } = state.error;
    return {
        quizzes, skillList,
        successEnable,
        successMessage,
        successMessageText,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ clearErrors, getQuizzes, getSkills }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(QuizList);
